module.exports = __webpack_public_path__ + "img/logo_text.f2a1804e.png";